// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"2c6481fa","808":"02b63c5a"}[chunkId] + ".chunk.js";
};